module.exports = __webpack_public_path__ + "img/two.6c3c135c.svg";